import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {
    ApiDeliveryAreasGetRequest,
    ApiDeliveryAreasGetRequestParams,
    ApiDeliveryAreasGetResponse
} from "@api/delivery-areas";
import {EnvironmentService} from "@iw-shop/core/services/environment.service";

@Injectable({
    providedIn: 'root'
})
export class DeliveryAreaService {

    constructor(private http: HttpClient, private environmentService: EnvironmentService) {
    }

    get(params: ApiDeliveryAreasGetRequestParams): Observable<ApiDeliveryAreasGetResponse> {
        const body: ApiDeliveryAreasGetRequest = {
            id: 'getDeliveryAreas',
            command: 'deliveryAreas/get',
            params: params
        };
        return this.http.post<ApiDeliveryAreasGetResponse>(this.environmentService.environment.urlApi, JSON.stringify(body));
    }
}
